export default __webpack_public_path__ + "static/media/bg-loan.d0a8f2f7.png";